var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailAddressVerifier(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 4.44048,
    y1: 0.88619,
    x2: 81.05694,
    y2: 83.47983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#81b673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48883,
    stopColor: "#438844"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006838"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78.17747,88.61091c-18.78499,2.12302-37.56996,2.12302-56.35494,0-5.49081-.62055-9.8129-4.94264-10.43345-10.43345-2.12301-18.78497-2.12301-37.56995,0-56.35493.62055-5.49081,4.94265-9.8129,10.43346-10.43345,18.78498-2.12301,37.56995-2.12301,56.35494,0,5.49081.62055,9.8129,4.94264,10.43346,10.43345,2.12301,18.78497,2.12301,37.56995,0,56.35492-.62055,5.49081-4.94265,9.8129-10.43345,10.43345Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M58.40997,47.78c1.72003-.73999,3.62006-1.14996,5.61005-1.14996,1.42999,0,2.81.20996,4.10999.60999v-16.19l-14.82001,11.22998,5.09998,5.5Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "25.66339 31.04745 25.66339 58.24637 40.48401 42.28238 25.66339 31.04745"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "65.09515 28.74814 28.69617 28.74814 46.89563 42.54459 65.09515 28.74814"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M55.19,49.70004l-4.82001-5.19-2.37,1.78998c-.32001.25-.71002.38-1.09998.38-.39001,0-.78003-.13-1.11005-.38l-2.37-1.78998-15.26001,16.42999h21.55005c0-4.56,2.13995-8.63,5.47998-11.23999Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M68.13,51.48093v-.00092c-.00293-.00128-.00604-.00208-.00897-.00336-.29297-.12708-.59363-.2392-.90002-.33905-.02228-.00726-.04333-.01697-.06561-.02405-.98804-.3147-2.03931-.48737-3.13165-.48737-.43085,0-.85284.03479-1.26984.08612-.08282.01013-.16321.02539-.24548.03748-.32178.04749-.63824.10876-.94958.1853-.05853.01422-.12079.01971-.17883.03491l.0083.00891c-1.26715.33459-2.43628.90173-3.46283,1.65704l-.00549-.00592c-.04474.03284-.08405.07239-.12823.1059-.21954.16705-.43152.34222-.63684.526-.08118.07251-.16248.14423-.24133.2193-.20294.19348-.39569.39648-.58228.60583-.06134.06879-.12604.13385-.18561.20422-.47791.56573-.89508,1.18292-1.24359,1.8432-.05151.09753-.09534.1991-.1438.29846-.1142.23444-.22223.47174-.31885.7157-.0498.12561-.09454.25305-.13947.38104-.08044.22931-.1524.46179-.2168.69818-.03723.13654-.07404.27246-.10571.41113-.05627.24658-.09949.49744-.1377.75043-.01965.12982-.04462.25745-.05939.38873-.03967.35376-.06226.71252-.06519,1.07617-.00024.02893-.00519.0567-.00519.08569h.00098c.00049,5.69519,4.61743,10.31183,10.31274,10.31183,5.69562,0,10.31287-4.61719,10.31287-10.31281,0-4.23535-2.55542-7.87061-6.2066-9.45813ZM62.98126,66.02737l-5.30804-5.30945,1.9964-1.9964,3.15588,3.15588.80627-.93738h.00824l.95996-1.11005-.00696-.00751,2.4043-2.79535.00269.00287,1.13-1.31v-.00977l.1759-.20453,2.14111,1.84058-7.46576,8.68109Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailAddressVerifier);
export default __webpack_public_path__ + "static/media/email-address-verifier.28b0000f685b30bace69cec737d1da58.svg";
export { ForwardRef as ReactComponent };